import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-documents-error-loader',
    imports: [CommonModule],
    standalone: true,
    templateUrl: './documents-error-loader.component.html',
    styleUrls: ['./documents-error-loader.component.scss']
})
export class DocumentsErrorLoaderComponent {
    @Input() text: string = 'Connection Failed';
    @Input() width: 'half' | 'full' = 'half';
    @Input() size: 'compact' | 'large' = 'compact';
    @Input() showText: boolean = true;

    get containerClasses(): string {
        return `${this.width}-width ${this.size}`;
    }
}
